export enum ComponentId {
  PERPETRATOR_NAME = "name",
  PERPETRATOR_SURNAME = "surname",
  PERPETRATOR_PHONE = "phone",
  PERPETRATOR_EMAIL = "email",
  PERPETRATOR_PESEL = "pesel",
  PERPETRATOR_STREET = "street",
  PERPETRATOR_STREET_2 = "street2",
  PERPETRATOR_ZIP_CODE_PL = "zipCodePL",
  PERPETRATOR_ZIP_CODE_GENERIC = "zipCodeGeneric",
  PERPETRATOR_CITY = "city",
  PERPETRATOR_COUNTRY = "country",
  PERPETRATOR_PROVINCE = "province",
  PERPETRATOR_OC_NUMBER = "ocNumber",
  PERPETRATOR_INSURANCE_COMPANY = "insuranceCompany",
}
